import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, InputNumber, Button, Modal, Select, Divider, Switch, Icon } from 'antd';
import { withState } from 'recompose';
import { values } from 'lodash';
const FormItem = Form.Item;
const { Option } = Select;

class UrbioticaCounterSettingsForm extends Component {

    state = {
        modalVisible: false
    }

    form = null;

    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleTypeChange = e => {
        if (e == 'U-Spot') {
            this.setState({
                disabled: false
            });
        } else {
            this.setState({
                disabled: true
            });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.onSuccess(this.props.form, values);
                this.props.onModalCancel(this.props.form);
            }
        });
    }

    renderForm() {
        const { getFieldDecorator } = this.props.form;
        const { disabled } = this.state;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label='POM'>
                    {getFieldDecorator('pom', {
                        initialValue: this.props.initialValues && this.props.initialValues.pom
                            ? this.props.initialValues.pom
                            : null,
                        rules: [{
                            type: 'number', message: 'Položka musí být number!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <InputNumber />
                    )}
                </FormItem>

                <FormItem {...tailFormItemLayout}>
                    {this.props.type && this.props.type !== 'modal'
                        ?
                        <Button type="primary" htmlType="submit">Vložit</Button>
                        :
                        <Button type="primary" htmlType="submit">Uložit</Button>
                    }
                </FormItem>

            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={700}
                    title="Nastavení čítače"
                    visible={this.state.modalVisible}
                    maskClosable={false}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                    onOk={this.handleSubmit} >
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedUrbioticaCounterSettingsForm = Form.create()(UrbioticaCounterSettingsForm);

export default WrappedUrbioticaCounterSettingsForm;


// WEBPACK FOOTER //
// ./src/components/UrbioticaCounterSettingsForm.js